import { Fragment, useState } from 'react'
import {
  Box,
  Button,
  Container,
  FilledInput,
  FormControl,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import { styled } from '@mui/styles'
import REGEX from '../../utils/regex/regex'
import './CheckoutShipmentForm.css'
import { useAuth } from '../../context/Auth/AuthContext'
import { getCarrierName } from '../../utils/auxFunc'

const CheckoutFormControl = styled(FormControl)(({ theme }) => ({
  marginBottom: '1rem',
  width: '100%',
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.light.main
  }
}))

const CheckoutRadio = styled(Radio)(({ theme }) => ({
  '& .Mui-checked': {
    color: theme.palette.secondary.main
  }
}))

const CheckoutShipmentForm = ({
  addresses,
  deliveryTimes,
  destinationForm,
  setDestinationForm,
  states,
  carriers,
  handleSubmit,
  Controller,
  control,
  register,
  errors,
  deliveryTimeOfProduct,
  handleChange,
  shipmentForm,
  errorMessages
}) => {
  const [edit, setEdit] = useState(false)
  const { userData } = useAuth()

  const toggleEdit = () => {
    setEdit(!edit)
  }

  const handleEdit = (data) => {
    setDestinationForm({
      ...destinationForm,
      ...data
    })
    toggleEdit()
  }

  const handleRadio = (evt) => {
    setDestinationForm({ ...destinationForm, ...JSON.parse(evt.target.value) })
  }

  return (
    <Fragment>
      <Container
        sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
      >
        <Box display="flex" justifyContent="space-between" pt={3}>
          <Typography
            variant="subtitle1"
            color={(theme) => theme.palette.light.main}
            sx={{
              fontSize: '1rem'
            }}
          >
            Dirección de envío:
          </Typography>
          <Box onClick={toggleEdit} sx={{ cursor: 'pointer' }}>
            <Typography
              variant="subtitle1"
              color={(theme) => theme.palette.light.main}
              sx={{
                fontSize: '1rem'
              }}
            >
              Modificar
            </Typography>
          </Box>
        </Box>
      </Container>
      {!edit ? (
        destinationForm.clientAddress.trim() !== '' &&
        destinationForm.clientZipCode.trim() !== '' &&
        destinationForm.clientTranspoName.trim() !== '' ? (
          <Fragment>
            <Container sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1.1rem',
                  textTransform: 'capitalize'
                }}
              >
                {`${destinationForm.clientAddress}`}
              </Typography>
              <Typography
                variant="subtitle1"
                color={(theme) => theme.palette.light.main}
                sx={{
                  fontSize: '1rem',
                  textTransform: 'capitalize'
                }}
              >
                {`${destinationForm.clientCity}, ${destinationForm.clientStateName} - CP: ${destinationForm.clientZipCode}`}
              </Typography>
            </Container>
            {addresses?.length > 0 && (
              <Fragment>
                <Container
                  sx={{
                    backgroundColor: (theme) => theme.palette.lightBg.main
                  }}
                >
                  <Box display="flex" justifyContent="space-between" pt={3}>
                    <Typography
                      variant="subtitle1"
                      color={(theme) => theme.palette.light.main}
                      sx={{
                        fontSize: '1rem'
                      }}
                    >
                      Seleccione una dirección:
                    </Typography>
                  </Box>
                </Container>
                <Container sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
                  <FormControl fullWidth>
                    <RadioGroup
                      aria-labelledby="Selección direcciones de envío"
                      defaultValue=""
                      name="opciones de envío"
                      onChange={handleRadio}
                    >
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        width="100%"
                      >
                        <Box display="flex" alignItems="center" width="100%">
                          <LocationOnOutlinedIcon />
                          <FormControlLabel
                            value={JSON.stringify({
                              clientAddressDescrp: 'principal',
                              clientAddress: userData.clientAddress,
                              clientFloor: userData.clientFloor,
                              clientDoor: userData.clientDoor,
                              clientCity: userData.clientCity,
                              clientStateId: userData.clientStateId,
                              clientStateName: userData.clientStateName,
                              clientZipCode: userData.clientZipCode,
                              clientTranspoName: userData.clientTranspoName
                            })}
                            checked={
                              destinationForm.clientAddressDescrp.toLowerCase() ===
                              'principal'
                            }
                            control={
                              <CheckoutRadio
                                sx={{
                                  '&.Mui-checked': {
                                    color: '#292929'
                                  }
                                }}
                              />
                            }
                            label={`Principal - ${userData.clientAddress}`}
                            labelPlacement="start"
                            sx={{
                              display: 'flex',
                              flex: 1,
                              justifyContent: 'space-between'
                            }}
                          />
                        </Box>
                        {addresses.map((address) => {
                          return (
                            <Box
                              display="flex"
                              alignItems="center"
                              width="100%"
                              key={address.addressId}
                            >
                              <LocationOnOutlinedIcon />
                              <FormControlLabel
                                value={JSON.stringify({
                                  clientAddressDescrp:
                                    address.clientAddressDescrp,
                                  clientAddress: address.clientAddress,
                                  clientFloor: address.clientFloor,
                                  clientDoor: address.clientDoor,
                                  clientCity: address.clientCity,
                                  clientStateId: address.clientStateId,
                                  clientStateName: address.clientStateName,
                                  clientZipCode: address.clientZipCode,
                                  clientTranspoName: getCarrierName(
                                    carriers,
                                    address.clientTranspoName
                                  )
                                })}
                                checked={
                                  destinationForm.clientAddressDescrp.toLowerCase() ===
                                  address.clientAddressDescrp.toLowerCase()
                                }
                                control={
                                  <CheckoutRadio
                                    sx={{
                                      '&.Mui-checked': {
                                        color: '#292929'
                                      }
                                    }}
                                  />
                                }
                                label={`${address.clientAddressDescrp} - ${address.clientAddress}`}
                                labelPlacement="start"
                                sx={{
                                  display: 'flex',
                                  flex: 1,
                                  justifyContent: 'space-between'
                                }}
                              />
                            </Box>
                          )
                        })}
                      </Box>
                    </RadioGroup>
                  </FormControl>
                  <Typography variant="caption" color="error">
                    {/* {error} */}
                  </Typography>
                </Container>
              </Fragment>
            )}
            <Container
              sx={{ backgroundColor: (theme) => theme.palette.lightBg.main }}
            >
              <Box display="flex" justifyContent="space-between" pt={3}>
                <Typography
                  variant="subtitle1"
                  color={(theme) => theme.palette.light.main}
                  sx={{
                    fontSize: '1rem'
                  }}
                >
                  Medio de transporte:
                </Typography>
              </Box>
            </Container>
            <Container sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontSize: '1.1rem',
                  textTransform: 'capitalize'
                }}
              >
                {destinationForm.clientTranspoName}
              </Typography>
            </Container>

            {shipmentForm.shipmentOption === 'caba' ? (
              <Fragment>
                <Container
                  sx={{
                    backgroundColor: (theme) => theme.palette.lightBg.main
                  }}
                >
                  <Box display="flex" justifyContent="space-between" pt={3}>
                    <Typography
                      variant="subtitle1"
                      color={(theme) => theme.palette.light.main}
                      sx={{
                        fontSize: '1rem'
                      }}
                    >
                      Horario de entrega:
                    </Typography>
                  </Box>
                </Container>
                <Container sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
                  <FormControl sx={{ minWidth: '100%' }}>
                    <Select
                      value={deliveryTimeOfProduct.deliveryId}
                      onChange={handleChange}
                      displayEmpty
                      inputProps={{
                        'aria-label': 'Horario para entrega de producto'
                      }}
                    >
                      <MenuItem value={0}>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            fontSize: '1.1rem'
                          }}
                        >
                          <em>Seleccione horario:</em>
                        </Typography>
                      </MenuItem>
                      {deliveryTimes.map((deliveryTime) => (
                        <MenuItem
                          value={deliveryTime.deliveryId}
                          key={deliveryTime.deliveryId}
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontSize: '1.1rem'
                            }}
                          >
                            {deliveryTime.description}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errorMessages.deliveryTime.status && (
                    <Typography variant="body1" color="error">
                      {errorMessages.deliveryTime.message}
                    </Typography>
                  )}
                </Container>
              </Fragment>
            ) : (
              ''
            )}
          </Fragment>
        ) : (
          <Fragment>
            <Container sx={{ pt: 3, pb: 3 }}>
              <Typography>
                Debes modificar los datos de envío y seleccionar un transporte
              </Typography>
              {errorMessages.destinationForm.status && (
                <Typography variant="body1" color="error">
                  {errorMessages.destinationForm.message}
                </Typography>
              )}
            </Container>
          </Fragment>
        )
      ) : (
        <Fragment>
          <Container sx={{ marginTop: '1rem', marginBottom: '1rem' }}>
            <Box
              component="form"
              onSubmit={handleSubmit((data) => handleEdit(data))}
            >
              <CheckoutFormControl fullWidth>
                <InputLabel>Dirección</InputLabel>
                <FilledInput
                  type="text"
                  {...register('clientAddress', {
                    required: 'Debe completar este campo'
                  })}
                  defaultValue={destinationForm.clientAddress || ''}
                ></FilledInput>
                {errors.clientAddress ? (
                  <Typography variant="caption" color="error">
                    {errors.clientAddress.message}
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ color: '#FAFAFA' }}>
                    <br />
                  </Typography>
                )}
              </CheckoutFormControl>
              <CheckoutFormControl fullWidth>
                <InputLabel>Piso</InputLabel>
                <FilledInput
                  type="text"
                  {...register('clientFloor')}
                  defaultValue={destinationForm.clientFloor || ''}
                ></FilledInput>
                {errors.clientFloor ? (
                  <Typography variant="caption" color="error">
                    {errors.clientFloor.message}
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ color: '#FAFAFA' }}>
                    <br />
                  </Typography>
                )}
              </CheckoutFormControl>
              <CheckoutFormControl>
                <InputLabel>Departamento</InputLabel>
                <FilledInput
                  type="text"
                  {...register('clientDoor')}
                  defaultValue={destinationForm.clientDoor || ''}
                ></FilledInput>
                {errors.clientDoor ? (
                  <Typography variant="caption" color="error">
                    {errors.clientDoor.message}
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ color: '#FAFAFA' }}>
                    <br />
                  </Typography>
                )}
              </CheckoutFormControl>
              <CheckoutFormControl>
                <InputLabel>Código Postal</InputLabel>
                <FilledInput
                  type="number"
                  {...register('clientZipCode', {
                    required: 'Debe completar este campo',
                    pattern: {
                      value: REGEX.lettersAndNumbersValidator,
                      message: 'Ingrese solo números y letras'
                    },
                    minLenght: 4
                  })}
                  defaultValue={destinationForm.clientZipCode || ''}
                ></FilledInput>
                {errors.shoclientZipCodepCP ? (
                  <Typography variant="caption" color="error">
                    {errors.clientZipCode.message}
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ color: '#FAFAFA' }}>
                    <br />
                  </Typography>
                )}
              </CheckoutFormControl>
              <CheckoutFormControl fullWidth>
                <InputLabel>Ciudad</InputLabel>
                <FilledInput
                  type="text"
                  {...register('clientCity', {
                    required: 'Debe completar este campo'
                  })}
                  defaultValue={destinationForm.clientCity || ''}
                ></FilledInput>
                {errors.shopclientCityCity ? (
                  <Typography variant="caption" color="error">
                    {errors.clientCity.message}
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ color: '#FAFAFA' }}>
                    <br />
                  </Typography>
                )}
              </CheckoutFormControl>
              <CheckoutFormControl variant="filled">
                <InputLabel>Provincia</InputLabel>
                <Controller
                  name="clientStateName"
                  control={control}
                  render={({ field }) => (
                    <Select
                      onChange={(data) => field.onChange(data)}
                      defaultValue={destinationForm.clientStateName || ''}
                      {...register('clientStateName', {
                        required: 'Debe seleccionar una provincia'
                      })}
                    >
                      {states?.map((state) => {
                        return (
                          <MenuItem
                            variant="filled"
                            key={state.idState}
                            value={state.nameState}
                            sx={{ textTransform: 'capitalize' }}
                          >
                            {state.nameState}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  )}
                />
                {errors.clientStateName ? (
                  <Typography variant="caption" color="error">
                    {errors.clientStateName.message}
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ color: '#FAFAFA' }}>
                    <br />
                  </Typography>
                )}
              </CheckoutFormControl>
              <CheckoutFormControl variant="filled">
                <InputLabel>Transporte</InputLabel>
                <Controller
                  name="clientTranspoName"
                  control={control}
                  render={({ field }) => (
                    <Select
                      onChange={(data) => field.onChange(data)}
                      defaultValue={destinationForm.clientTranspoName}
                      MenuProps={{
                        style: { maxHeight: '300px' }
                      }}
                      {...register('clientTranspoName', {
                        required: 'Debe seleccionar un transporte'
                      })}
                    >
                      {carriers?.map((carrier) => {
                        return (
                          <MenuItem
                            variant="filled"
                            key={carrier.id}
                            value={carrier.name}
                            sx={{ textTransform: 'capitalize' }}
                          >
                            {carrier.name}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  )}
                />
                {errors.clientTranspoName ? (
                  <Typography variant="caption" color="error">
                    {errors.clientTranspoName.message}
                  </Typography>
                ) : (
                  <Typography variant="caption" sx={{ color: '#FAFAFA' }}>
                    <br />
                  </Typography>
                )}
              </CheckoutFormControl>
              <Button
                type="sumbit"
                color="secondary"
                variant="contained"
                fullWidth
                sx={{ textTransform: 'capitalize', marginTop: '1rem' }}
              >
                Confirmar datos
              </Button>
            </Box>
          </Container>
        </Fragment>
      )}
    </Fragment>
  )
}

export default CheckoutShipmentForm
